(function(){
  if (window.__fdt) return; window.__fdt = true;
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-fdt-prev],[data-fdt-next]');
    if (b) {
      var s = b.closest('section');
      var t = s && s.querySelector('[data-fdt-track]');
      if (t) {
        var c = t.firstElementChild;
        var w = c ? c.getBoundingClientRect().width + 20 : 300;
        t.scrollBy({ left: b.hasAttribute('data-fdt-next') ? w : -w, behavior: 'smooth' });
      }
      return;
    }
    var p = e.target.closest('[data-fdt-play]');
    if (p) {
      var v = p.parentElement.querySelector('video');
      if (v) { v.muted = false; v.controls = true; v.play(); p.hidden = true; }
      return;
    }
    var st = e.target.closest('[data-fdt-scrolltop]');
    if (st && (st.getAttribute('href') || '#') === '#') {
      e.preventDefault();
      var f = document.querySelector('form[action*="/cart/add"]');
      var y = f ? f.getBoundingClientRect().top + window.scrollY - 160 : 0;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
  });
  function pad(n){ return String(n).padStart(2, '0'); }
  function countdown(){
    var els = document.querySelectorAll('[data-fdt-countdown]');
    if (!els.length) return;
    var now = new Date(), end = new Date(now);
    end.setHours(23, 59, 59, 999);
    var d = Math.max(0, Math.floor((end - now) / 1000));
    var txt = pad(Math.floor(d / 3600)) + ':' + pad(Math.floor(d % 3600 / 60)) + ':' + pad(d % 60);
    els.forEach(function(el){ el.textContent = txt; });
  }
  countdown(); setInterval(countdown, 1000);
  function timeline(){
    var items = document.querySelectorAll('.fdt-tl__item');
    if (!items.length || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('.fdt-tl').forEach(function(s){ s.classList.add('fdt-tl--anim'); });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) { en.target.classList.add('is-active'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -30% 0px' });
    items.forEach(function(i){ io.observe(i); });
  }
  if (document.readyState !== 'loading') timeline(); else document.addEventListener('DOMContentLoaded', timeline);
  document.addEventListener('shopify:section:load', timeline);
})();
